import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { DocumentsKpiDashboard } from './components/DocumentsKpiDashboard';
import { DocumentsModulesGrid } from './components/DocumentsModulesGrid';
import { RecentDocumentActivity } from './components/RecentDocumentActivity';

export function DocumentsPage() {
  return (
    <PageLayout
      title="Tài liệu & Hồ sơ"
      description="Trung tâm lưu trữ, kiểm soát phiên bản và số hóa tài liệu, hợp đồng, bản vẽ"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <DocumentsKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Vận hành Tài liệu (Document Operations)
              </h3>
            </div>
            <div className="flex-1">
              <DocumentsModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động gần đây
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentDocumentActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default DocumentsPage;
